module.exports = __webpack_public_path__ + "static/media/sumant.b5ada364.jpg";